import { CONVENTIONAL, FOV_PREVIEW_WIDTH, FOV_PREVIEW_HEIGHT } from 'helpers/globals'
import setComponentValues from 'helpers/fovPreview/setComponentValues'
import { multiplier } from 'helpers/fovPreview/backgroundSize'

function convert({ backgroundPositionX, backgroundPositionY, backgroundSizeX, backgroundSizeY, conventional, angleOfView, containerHeight, containerWidth, toOriginal, aspectRatio }) {
  const subCenterX = toOriginal ? containerWidth / 2 : FOV_PREVIEW_WIDTH / 2
  const addCenterX = toOriginal ? FOV_PREVIEW_WIDTH / 2 : containerWidth / 2
  const subCenterY = toOriginal ? containerHeight / 2 : FOV_PREVIEW_HEIGHT / 2
  const addCenterY = toOriginal ? FOV_PREVIEW_HEIGHT / 2 : containerHeight / 2

  const multiple = multiplier({ angleOfView, conventional, aspectRatio })
  const originalSizeX = conventional ? (FOV_PREVIEW_WIDTH + FOV_PREVIEW_WIDTH * multiple) : (FOV_PREVIEW_HEIGHT + FOV_PREVIEW_HEIGHT * multiple)
  let scale = (conventional ? backgroundSizeX : backgroundSizeY) / originalSizeX
  if (toOriginal) scale = 1 / scale

  if (conventional) {
    return {
      backgroundPositionX: (backgroundPositionX - subCenterX) * scale + addCenterX,
      backgroundPositionY: (backgroundPositionY - subCenterY) * scale + addCenterY
    }
  }
  return {
    backgroundPositionX: (backgroundPositionX - subCenterY) * scale + addCenterY,
    backgroundPositionY: (backgroundPositionY - subCenterX) * scale + addCenterX
  }
}

export function convertToOriginal({ backgroundPositionX, backgroundPositionY, backgroundSize: { backgroundSizeX, backgroundSizeY }, conventional, angleOfView, containerHeight, containerWidth, aspectRatio }) {
  return convert({ backgroundPositionX, backgroundPositionY, backgroundSizeX, backgroundSizeY, conventional, angleOfView, containerHeight, containerWidth, toOriginal: true, aspectRatio })
}

export function convertToScaled({ containerWidth, containerHeight, aspectRatio, ...props }) {
  const { angleOfView, conventional, backgroundSize: { backgroundSizeX, backgroundSizeY } } = setComponentValues({ prevState: { containerWidth, containerHeight }, aspectRatio, ...props })
  const { backgroundPositionX, backgroundPositionY } = props.backgroundPosition

  return convert({ backgroundPositionX, backgroundPositionY, backgroundSizeX, backgroundSizeY, conventional, angleOfView, containerHeight, containerWidth, toOriginal: false, aspectRatio })
}



// WEBPACK FOOTER //
// ./src/helpers/fovPreview/convert.js